import { render, staticRenderFns } from "./hscodesIndex.pug?vue&type=template&id=6626597f&lang=pug&"
import script from "./hscodesIndex.ts?vue&type=script&lang=ts&"
export * from "./hscodesIndex.ts?vue&type=script&lang=ts&"
import style0 from "./hscodesIndex.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports